import { Injectable } from '@angular/core';
import {
  AddShippingAddressEvent,
  AddToFavoritesEvent,
  AddToShoppingCartEvent,
  AnalyticsService,
  BeginCheckoutEvent,
  GenerateLeadEvent,
  HomeAssistanceEvent,
  LeadCreationEvent,
  MortgageSimulatorEvent,
  MovingEvent,
  ProjectSimulatorEvent,
  PurchaseEvent,
  RealEstateProjectInformationRequestEvent,
  RemodelingEvent,
  RemodelingSimulatorEvent,
  RemoveFromShoppingCartEvent,
  SearchEvent,
  SeeMoreFinancingOptionsEvent,
  ShoppingCartUpdateEvent,
  SignInEvent,
  SignUpEvent,
  UserCreationEvent,
  ViewItemEvent,
  ViewShoppingCartEvent,
  WarehouseEvent,
} from './analytics.service';

@Injectable()
export class AnalyticsServiceMock implements AnalyticsService {
  logAddShippingAddressEvent(data: AddShippingAddressEvent): void {
    console.log('Analytic event add_shipping_info', data);
  }

  logAddToFavoritesEvent(data: AddToFavoritesEvent): void {
    console.log('Analytic event add_to_wishlist', data);
  }

  logAddToShoppingCartEvent(data: AddToShoppingCartEvent): void {
    console.log('Analytic event add_to_cart', data);
  }

  logBeginCheckoutEvent(data: BeginCheckoutEvent): void {
    console.log('Analytic event begin_checkout', data);
  }

  logExperimentEvent(data: Record<string, unknown>): void {
    console.log('Analytic event experiment', data);
  }

  logGenerateLeadEvent(data: GenerateLeadEvent): void {
    console.log('Analytic event generate_lead', data);
  }

  logHomeAssistanceEvent(data: HomeAssistanceEvent): void {
    console.log('Analytic event home_assistance', data);
  }

  logLeadsForm(data: LeadCreationEvent): void {
    console.log('Analytics event leads_form', data);
  }
  logMortgageSimulatorEvent(data: MortgageSimulatorEvent): void {
    console.log('Analytic event mortgage_simulator', data);
  }

  logMovingEvent(data: MovingEvent): void {
    console.log('Analytic event moving', data);
  }

  logPartnerLeadsForm(data: LeadCreationEvent): void {
    console.log('Analytic event partner_leads_form', data);
  }

  logProjectSimulatorEvent(data: ProjectSimulatorEvent): void {
    console.log('Analytic event project_simulator', data);
  }

  logPurchaseEvent(data: PurchaseEvent): void {
    console.log('Analytic event purchase', data);
  }

  logRealEstateProjectInformationRequestEvent(data: RealEstateProjectInformationRequestEvent): void {
    console.log('Analytic event real_estate_project_information_request', data);
  }

  logRemodelingEvent(data: RemodelingEvent): void {
    console.log('Analytic event remodeling', data);
  }

  logRemodelingSimulatorEvent(data: RemodelingSimulatorEvent): void {
    console.log('Analytic event remodeling_simulator', data);
  }

  logRemoveFromShoppingCartEvent(data: RemoveFromShoppingCartEvent): void {
    console.log('Analytic event remove_from_cart', data);
  }

  logSearchEvent(data: SearchEvent): void {
    console.log('Analytic event search', data);
  }

  logSeeMoreFinancingOptionsEvent(data: SeeMoreFinancingOptionsEvent): void {
    console.log('Analytic event see_more_financing_options', data);
  }

  logShoppingCartUpdateEvent(data: ShoppingCartUpdateEvent): void {
    console.log('Analytic event cart_updated', data);
  }

  logSignInEvent(data: SignInEvent): void {
    console.log('Analytic event login', data);
  }

  logSignUpEvent(data: SignUpEvent): void {
    console.log('Analytic event sign_up', data);
  }

  logUserCreationEvent(data: UserCreationEvent): void {
    console.log('Analytic event user_creation', data);
  }

  logViewItemEvent(data: ViewItemEvent): void {
    console.log('Analytic event view_item', data);
  }

  logViewShoppingCartEvent(data: ViewShoppingCartEvent): void {
    console.log('Analytic event view_cart', data);
  }

  logWarehouseEvent(data: WarehouseEvent): void {
    console.log('Analytic event warehouse', data);
  }
}
